import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { useT } from "@/lib/i18n";
import { useCatalog } from "@/lib/data";
import { fileUrl } from "@/lib/api";
import { CategoryIcon } from "@/lib/icons";
import { VerifiedBadge } from "@/components/Bits";
import { RatingPill, TopRatedBadge } from "@/components/ReviewBits";
import { ChecksPill } from "@/components/VerifyList";
import ContactButtons from "@/components/ContactButtons";

export default function BusinessCard({ b }) {
  const { t, tn, lp } = useT();
  const { catById, locById } = useCatalog();
  const cat = catById[b.category_id];
  return (
    <article className="rounded-2xl border border-line bg-white p-4 shadow-sm transition-shadow hover:shadow-md" data-testid={`business-card-${b.id}`}>
      <Link to={lp(b.slug ? `/s/${b.slug}` : `/b/${b.id}`)} className="flex gap-3" data-testid={`business-card-link-${b.id}`}>
        {b.photos?.[0] ? (
          <img src={fileUrl(b.photos[0], 400)} alt={b.name} loading="lazy" decoding="async" className="h-20 w-20 flex-shrink-0 rounded-xl border border-line object-cover" />
        ) : (
          <div className="grid h-20 w-20 flex-shrink-0 place-items-center rounded-xl bg-saffron-50 text-saffron">
            <CategoryIcon name={cat?.icon} className="h-8 w-8" />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <h3 className="truncate font-display text-lg font-bold leading-tight text-ink" data-testid="business-card-name">{b.name}</h3>
          {["featured", "top"].includes(b.plan) && <span className="mt-0.5 inline-block rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-amber-900" data-testid="business-card-promoted">{t("promoted")}</span>}
          <p className="mt-0.5 flex items-center gap-1 truncate text-sm text-slate-500">
            {tn(cat?.name)} · <MapPin className="h-3.5 w-3.5" /> {tn(locById[b.locality_id]?.name)}
          </p>
          <div className="mt-1.5 flex flex-wrap items-center gap-1.5"><RatingPill b={b} testid="business-card-rating" />{b.top_rated && <TopRatedBadge testid="business-card-top-rated" />}<ChecksPill b={b} /></div>
          <div className="mt-2"><VerifiedBadge date={b.verified_at} /></div>
        </div>
      </Link>
      <div className="mt-3"><ContactButtons business={b} /></div>
    </article>
  );
}
